"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verifyAndImportElements = exports.updateSettings = exports.updateList = exports.updateCurrentElementSettings = exports.unsetLoadingState = exports.undoChanges = exports.toggleElementPreview = exports.storageKey = exports.setRootId = exports.setProjectId = exports.setLoadingState = exports.setListWithoutRestore = exports.setList = exports.setLanguage = exports.setAssignmentId = exports.savedKeys = exports.saveStateInStorage = exports.savePlayerSettings = exports.saveFlow = exports.saveDataDefinitions = exports.restoreState = exports.resetFlow = exports.removeRedos = exports.redoChanges = exports.moveElementToTrashWithoutChecking = exports.moveElementToTrash = exports.moveElementFromTrash = exports.moveElement = exports.loadFlow = exports.initializeSavedList = exports.initialState = exports.initialSettings = exports.importElements = exports.duplicateElement = exports["default"] = exports.completeSectionTree = exports.changeViewModeWithoutSave = exports.changeViewMode = exports.changePreviewSizeWithoutSave = exports.changePreviewSize = exports.changeCurrentElementWithoutSave = exports.changeCurrentElement = exports.batchUpdateAudio = exports.addElement = void 0;
var _reduxActions = require("redux-actions");
var _map2 = _interopRequireDefault(require("lodash/map"));
var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _pickBy2 = _interopRequireDefault(require("lodash/pickBy"));
var _difference2 = _interopRequireDefault(require("lodash/difference"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));
var _isObject2 = _interopRequireDefault(require("lodash/isObject"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _set2 = _interopRequireDefault(require("lodash/set"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _helpers = require("../other/helpers.js");
var _builder = require("../selectors/builder.js");
var _store = _interopRequireDefault(require("store"));
var _allElements = _interopRequireDefault(require("../allElements.js"));
var _allTemplates = require("../allTemplates.js");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _config = _interopRequireDefault(require("../config.js"));
var _window$cccisd, _handleActions;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var AppDefs = window.cccisd && window.cccisd.appDefs;
var Resources = (_window$cccisd = window.cccisd) === null || _window$cccisd === void 0 ? void 0 : _window$cccisd.resources;
var dynamicDataConnectors = AppDefs && AppDefs.flow && AppDefs.flow.variables || [];
var dynamicUserLists = AppDefs && AppDefs.flow && AppDefs.flow.userLists || [];
var defaultValues = AppDefs && AppDefs.flow && AppDefs.flow.defaultValues || [];
var storageKey = 'CccisdFlowCurrent'; // key for browser local storage
exports.storageKey = storageKey;
var savedKeys = ['currentElementId', 'viewMode', 'previewSize'];

// Initial state
exports.savedKeys = savedKeys;
var initialSettings = {
  name: 'Flow',
  handle: '',
  type: '',
  showOneElementPerPage: false,
  showRequiredState: false,
  showQuestionNumbers: false,
  showAdvancedSettings: false,
  overrideAccommodations: false,
  accommodations: {
    masking: false,
    highlighting: false,
    autoplayQuestions: false,
    autoplayChoices: false,
    autoplayInstructions: true,
    blockUserInteractions: false
  },
  playerTemplate: 'default',
  playerTemplateSettings: {}
};
exports.initialSettings = initialSettings;
var initialState = {
  loading: false,
  elements: {},
  trash: [],
  currentElementId: 0,
  viewMode: 'preview',
  savedHash: '',
  savedElements: {},
  projectId: 0,
  assignmentId: 0,
  rootId: 0,
  newId: 1000000000,
  settings: initialSettings,
  previewSize: 'desktop',
  dynamicDataConnectors: (0, _helpers.checkForUniqueHandle)(dynamicDataConnectors),
  dynamicUserLists: (0, _helpers.checkForUniqueHandle)(dynamicUserLists),
  defaultValues: (0, _helpers.checkForUniqueHandle)(defaultValues),
  language: 'en',
  voices: Resources ? Object.entries(Resources.tts.voices).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return {
      language: value.LanguageCode.slice(0, 2),
      languageName: value.language,
      label: value.label,
      value: key,
      gender: value.Gender,
      url: value.url,
      order: function () {
        // Put Pedro and Miguel at the beginning of the list
        if (key === 'Pedro') {
          return -2;
        }
        if (key === 'Miguel') {
          return -1;
        }
        return 0;
      }()
    };
  }).sort(function (a, b) {
    return a.order - b.order;
  }) : [],
  allElements: _allElements["default"],
  config: _config["default"]
};

// Actions
exports.initialState = initialState;
var SET_LOADING_STATE = 'flow/builder/SET_LOADING_STATE';
var UNSET_LOADING_STATE = 'flow/builder/UNSET_LOADING_STATE';
var RESET_FLOW = 'flow/builder/RESET_FLOW';
var CHANGE_CURRENT_ELEMENT = 'flow/builder/CHANGE_CURRENT_ELEMENT';
var ADD_ELEMENT = 'flow/builder/ADD_ELEMENT';
var IMPORT_ELEMENTS = 'flow/builder/IMPORT_ELEMENTS';
var MOVE_ELEMENT = 'flow/builder/MOVE_ELEMENT';
var MOVE_ELEMENT_TO_TRASH = 'flow/builder/MOVE_ELEMENT_TO_TRASH';
var MOVE_ELEMENT_FROM_TRASH = 'flow/builder/MOVE_ELEMENT_FROM_TRASH';
var CHANGE_VIEW_MODE = 'flow/builder/CHANGE_VIEW_MODE';
var UPDATE_CURRENT_ELEMENT_SETTINGS = 'flow/builder/UPDATE_CURRENT_ELEMENT_SETTINGS';
var TOGGLE_ELEMENT_PREVIEW = 'flow/builder/TOGGLE_ELEMENT_PREVIEW';
var INITIALIZE_SAVED_LIST = 'flow/builder/INITIALIZE_SAVED_LIST';
var SET_LIST = 'flow/builder/SET_LIST';
var UPDATE_LIST = 'flow/builder/UPDATE_LIST';
var REMOVE_REDOS = 'flow/builder/REMOVE_REDOS';
var UNDO_CHANGES = 'flow/builder/UNDO_CHANGES';
var REDO_CHANGES = 'flow/builder/REDO_CHANGES';
var UPDATE_SETTINGS = 'flow/builder/UPDATE_SETTINGS';
var SET_ROOT_ID = 'flow/builder/SET_ROOT_ID';
var RESTORE_STATE = 'flow/builder/RESTORE_STATE';
var COMPLETE_SECTION_TREE = 'flow/builder/COMPLETE_SECTION_TREE';
var CHANGE_PREVIEW_SIZE = 'flow/builder/CHANGE_PREVIEW_SIZE';
var SET_PROJECT_ID = 'flow/builder/SET_PROJECT_ID';
var SET_ASSIGNMENT_ID = 'flow/builder/SET_ASSIGNMENT_ID';
var SET_LANGUAGE = 'flow/builder/SET_LANGUAGE';
var BATCH_UPDATE_AUDIO = 'flow/builder/BATCH_UPDATE_AUDIO';

// Action Creators
var setLoadingState = (0, _reduxActions.createAction)(SET_LOADING_STATE);
exports.setLoadingState = setLoadingState;
var unsetLoadingState = (0, _reduxActions.createAction)(UNSET_LOADING_STATE);
exports.unsetLoadingState = unsetLoadingState;
var resetFlow = (0, _reduxActions.createAction)(RESET_FLOW);
exports.resetFlow = resetFlow;
var changeCurrentElementWithoutSave = (0, _reduxActions.createAction)(CHANGE_CURRENT_ELEMENT);
exports.changeCurrentElementWithoutSave = changeCurrentElementWithoutSave;
var addElement = (0, _reduxActions.createAction)(ADD_ELEMENT);
exports.addElement = addElement;
var importElements = (0, _reduxActions.createAction)(IMPORT_ELEMENTS);
exports.importElements = importElements;
var moveElement = (0, _reduxActions.createAction)(MOVE_ELEMENT);
exports.moveElement = moveElement;
var moveElementToTrashWithoutChecking = (0, _reduxActions.createAction)(MOVE_ELEMENT_TO_TRASH);
exports.moveElementToTrashWithoutChecking = moveElementToTrashWithoutChecking;
var moveElementFromTrash = (0, _reduxActions.createAction)(MOVE_ELEMENT_FROM_TRASH);
exports.moveElementFromTrash = moveElementFromTrash;
var changeViewModeWithoutSave = (0, _reduxActions.createAction)(CHANGE_VIEW_MODE);
exports.changeViewModeWithoutSave = changeViewModeWithoutSave;
var updateCurrentElementSettings = (0, _reduxActions.createAction)(UPDATE_CURRENT_ELEMENT_SETTINGS);
exports.updateCurrentElementSettings = updateCurrentElementSettings;
var toggleElementPreview = (0, _reduxActions.createAction)(TOGGLE_ELEMENT_PREVIEW);
exports.toggleElementPreview = toggleElementPreview;
var initializeSavedList = (0, _reduxActions.createAction)(INITIALIZE_SAVED_LIST);
exports.initializeSavedList = initializeSavedList;
var setListWithoutRestore = (0, _reduxActions.createAction)(SET_LIST);
exports.setListWithoutRestore = setListWithoutRestore;
var updateList = (0, _reduxActions.createAction)(UPDATE_LIST);
exports.updateList = updateList;
var removeRedos = (0, _reduxActions.createAction)(REMOVE_REDOS);
exports.removeRedos = removeRedos;
var undoChanges = (0, _reduxActions.createAction)(UNDO_CHANGES);
exports.undoChanges = undoChanges;
var redoChanges = (0, _reduxActions.createAction)(REDO_CHANGES);
exports.redoChanges = redoChanges;
var updateSettings = (0, _reduxActions.createAction)(UPDATE_SETTINGS);
exports.updateSettings = updateSettings;
var setRootId = (0, _reduxActions.createAction)(SET_ROOT_ID);
exports.setRootId = setRootId;
var restoreState = (0, _reduxActions.createAction)(RESTORE_STATE);
exports.restoreState = restoreState;
var completeSectionTree = (0, _reduxActions.createAction)(COMPLETE_SECTION_TREE);
exports.completeSectionTree = completeSectionTree;
var changePreviewSizeWithoutSave = (0, _reduxActions.createAction)(CHANGE_PREVIEW_SIZE);
exports.changePreviewSizeWithoutSave = changePreviewSizeWithoutSave;
var setProjectId = (0, _reduxActions.createAction)(SET_PROJECT_ID);
exports.setProjectId = setProjectId;
var setAssignmentId = (0, _reduxActions.createAction)(SET_ASSIGNMENT_ID);
exports.setAssignmentId = setAssignmentId;
var setLanguage = (0, _reduxActions.createAction)(SET_LANGUAGE);
exports.setLanguage = setLanguage;
var batchUpdateAudio = (0, _reduxActions.createAction)(BATCH_UPDATE_AUDIO);
exports.batchUpdateAudio = batchUpdateAudio;
var moveElementToTrash = function moveElementToTrash(id) {
  return function (dispatch, getState) {
    var state = getState().flow.builder;
    if (!(0, _helpers.allowRemoveElement)(state.elements, state.rootId, id)) {
      (0, _cccisdNotification["default"])({
        message: 'You cannot delete this element because other elements have data connectors linked to it',
        type: 'danger',
        duration: 10000
      });
    } else {
      dispatch(moveElementToTrashWithoutChecking(id));
    }
  };
};
exports.moveElementToTrash = moveElementToTrash;
var setList = function setList() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return function (dispatch, getState) {
    dispatch(setListWithoutRestore.apply(void 0, args));
    dispatch(restoreState({
      savedState: _store["default"].get(storageKey) || {},
      keys: savedKeys
    }));
  };
};
exports.setList = setList;
var saveStateInStorage = function saveStateInStorage() {
  return function (dispatch, getState) {
    var state = getState().flow.builder;
    if (state.rootId !== 0) {
      var saved = _store["default"].get(storageKey) || {};
      saved[state.rootId] = (0, _pick2["default"])(state, savedKeys);
      _store["default"].set(storageKey, saved);
    }
  };
};
exports.saveStateInStorage = saveStateInStorage;
var changeCurrentElement = function changeCurrentElement() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  return function (dispatch, getState) {
    dispatch(changeCurrentElementWithoutSave.apply(void 0, args));
    dispatch(saveStateInStorage());
  };
};
exports.changeCurrentElement = changeCurrentElement;
var changeViewMode = function changeViewMode() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  return function (dispatch, getState) {
    dispatch(changeViewModeWithoutSave.apply(void 0, args));
    dispatch(saveStateInStorage());
  };
};
exports.changeViewMode = changeViewMode;
var changePreviewSize = function changePreviewSize() {
  for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(dispatch, getState) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch(changePreviewSizeWithoutSave.apply(void 0, args));
            dispatch(saveStateInStorage());

            // just to trigger all resize listeners
            // wait to finish animation
            _context.next = 4;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 500);
            });
          case 4:
            window.dispatchEvent(new Event('resize'));
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
exports.changePreviewSize = changePreviewSize;
var verifyAndImportElements = function verifyAndImportElements(_ref4) {
  var content = _ref4.content,
    parentId = _ref4.parentId,
    beforeId = _ref4.beforeId;
  return function (dispatch, getState) {
    try {
      var data = JSON.parse(content);
      var hash = (0, _helpers.getObjectHash)((0, _omit2["default"])(data, ['hash']));
      if (hash !== data.hash) {
        throw new Error("Hash doesn't match");
      }
      if (data.version !== _config["default"].exportVersion) {
        throw new Error("The import file version ".concat(data.version, " is not supported"));
      }

      // Check if components exist
      (function () {
        var state = getState().flow.builder;
        var flowTypes = (0, _helpers.getFlowTypes)();
        var importingTypes = (0, _filter2["default"])(data.elements, function (o) {
          return o.type;
        }).map(function (o) {
          return o.type;
        });
        var existingTypes = flowTypes[state.settings.type].components;
        var diff = (0, _uniq2["default"])((0, _difference2["default"])(importingTypes, existingTypes));
        if (diff.length > 0) {
          throw new Error("The are missing components: \"".concat(diff.join('", "'), "\""));
        }
      })();

      // Check if templates exist
      (function () {
        var importingTemplates = (0, _filter2["default"])(data.elements, function (o) {
          return o.type && o.settings && o.settings.template;
        }).reduce(function (result, o) {
          result[o.type] = result[o.type] || [];
          if (!result[o.type].includes(o.settings.template)) {
            result[o.type].push(o.settings.template);
          }
          return result;
        }, {});
        (0, _forEach2["default"])(importingTemplates, function (value, key) {
          var list = (0, _allTemplates.getTemplateList)('components', key).map(function (o) {
            return o.name;
          });
          var diff = (0, _difference2["default"])(value, list);
          if (diff.length > 0) {
            throw new Error("The are missing templates for the \"".concat(key, "\" element: \"").concat(diff.join('", "'), "\""));
          }
        });
      })();

      // Check if player templates exist
      (function () {
        var importingTemplates = (0, _uniq2["default"])((0, _filter2["default"])(data.elements, function (o) {
          return o.settings && o.settings.blockPlayerTemplate;
        }).map(function (o) {
          return o.settings.blockPlayerTemplate;
        }));
        var existingTemplates = (0, _allTemplates.getTemplateList)('players', 'flow').map(function (o) {
          return o.name;
        });
        var diff = (0, _difference2["default"])(importingTemplates, existingTemplates);
        if (diff.length > 0) {
          throw new Error("The are missing player templates: \"".concat(diff.join('", "'), "\""));
        }
      })();
      dispatch(importElements(_objectSpread(_objectSpread({}, (0, _pick2["default"])(data, ['elements', 'topId'])), {}, {
        parentId: parentId,
        beforeId: beforeId
      })));
      (0, _cccisdNotification["default"])('The flow has been imported');
    } catch (e) {
      (0, _cccisdNotification["default"])({
        message: e.message,
        type: 'danger',
        duration: 10000
      });
    }
  };
};
exports.verifyAndImportElements = verifyAndImportElements;
var duplicateElement = function duplicateElement(id) {
  return function (dispatch, getState) {
    var state = getState().flow.builder;
    var parent = (0, _find2["default"])(state.elements, function (item) {
      return item.children && item.children.includes(id);
    });
    var parentChildren = parent.children;
    var index = parentChildren.indexOf(id);
    // If there is no next element then it will pass undefined
    var beforeId = parentChildren[index + 1];
    var data = (0, _helpers.exportFlow)({
      elements: state.elements,
      topId: id,
      theSameFlow: true
    });
    dispatch(importElements({
      elements: data.elements,
      topId: data.topId,
      parentId: parent.id,
      beforeId: beforeId
    }));
  };
};
exports.duplicateElement = duplicateElement;
var saveDataDefinitions = function saveDataDefinitions(flowId, codebookId) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch, getState) {
      var state, dataDefinitions, repeatableDataDefinitions, count, metricsVariables, variables, typeMatch, data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            state = getState();
            dataDefinitions = {};
            repeatableDataDefinitions = {};
            count = 1;
            (0, _builder.getElementsInOrder)(state.flow.builder).forEach(function (element) {
              var elementType = (0, _find2["default"])(_allElements["default"], {
                code: element.type
              });

              // Regular data definitions
              if (elementType && (0, _isFunction2["default"])(elementType.getDataDefinitions)) {
                var elementDefinitions = elementType.getDataDefinitions(element.id, element.settings);
                Object.assign(dataDefinitions, (0, _mapValues2["default"])(elementDefinitions, function (item) {
                  return _objectSpread(_objectSpread({}, item), {}, {
                    order: count++
                  });
                }));
                var title = "Duration for entity ".concat(element.id);
                Object.values(elementDefinitions).forEach(function (value) {
                  if (value.title) {
                    title = value.title;
                  }
                });
                var prefix = '';
                if ((0, _isFunction2["default"])(elementType.getMetricsPrefix)) {
                  prefix = elementType.getMetricsPrefix() + '_';
                }
                dataDefinitions["".concat(element.id, "_duration")] = {
                  questionType: element.type,
                  label: "Duration for entity ".concat(element.id),
                  title: title,
                  titleHtml: title,
                  type: 'number',
                  reportHeader: "".concat(prefix).concat(element.id, "_duration"),
                  variableType: 'detailed_usage',
                  tags: {
                    system: ['duration']
                  },
                  order: count++
                };
              }

              // Repeatable data definitions
              if (elementType && (0, _isFunction2["default"])(elementType.getRepeatableDataDefinitions)) {
                var _elementDefinitions = elementType.getRepeatableDataDefinitions(element.id, element.settings);
                Object.assign(repeatableDataDefinitions, (0, _mapValues2["default"])(_elementDefinitions, function (item) {
                  return _objectSpread(_objectSpread({}, item), {}, {
                    order: count++
                  });
                }));
              }
            });

            // Get data definitions for variables
            metricsVariables = state.flow.builder.settings.metricsVariables || [];
            variables = (0, _get2["default"])(window, 'cccisd.appDefs.flow.variables', []).filter(function (item) {
              return ['string', 'number'].includes(item.type) && metricsVariables.includes(item.handle);
            });
            typeMatch = {
              string: 'string',
              number: 'int'
            };
            variables.forEach(function (variable) {
              dataDefinitions["".concat(flowId, "_app_variable_").concat(variable.handle)] = {
                questionType: 'appVariable',
                label: variable.label,
                title: variable.label,
                titleHtml: variable.label,
                type: typeMatch[variable.type] || variable.type,
                reportHeader: "app_variable_".concat(variable.handle),
                variableType: 'detailed_usage',
                tags: {
                  system: ['app_variable']
                },
                order: count++
              };
            });
            dataDefinitions = {
              $schema: 'http://json-schema.org/draft-04/schema#',
              title: state.flow.builder.settings.name,
              sourceType: 'flow',
              sourceId: flowId,
              type: 'object',
              properties: _objectSpread({}, dataDefinitions),
              patternProperties: _objectSpread({}, repeatableDataDefinitions)
            };
            data = {
              definition: JSON.stringify(dataDefinitions)
            };
            if (codebookId) {
              data.codebook_id = codebookId;
            }
            _context2.next = 14;
            return _cccisdAxios["default"].post(Boilerplate.route('metrics.api.v1.source.definition'), data);
          case 14:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x4, _x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};
exports.saveDataDefinitions = saveDataDefinitions;
var loadFlow = function loadFlow(flowId) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(dispatch, getState) {
      var response, attributes, settings;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            dispatch(resetFlow());
            dispatch(setLoadingState());

            // Get flow data
            _context3.next = 4;
            return _cccisdAxios["default"].get(Boilerplate.route('flow.show', {
              flow: flowId
            }));
          case 4:
            response = _context3.sent;
            attributes = response.data.data.attributes;
            settings = _objectSpread(_objectSpread({}, _typeof(attributes.settings) === 'object' ? attributes.settings : {}), {}, {
              name: attributes.name,
              handle: attributes.handle || '',
              type: attributes.type,
              language: attributes.language
            });
            dispatch(setProjectId(response.data.data.group.id));
            dispatch(setAssignmentId(response.data.data.assignment.id));
            dispatch(setLanguage(attributes.language));
            dispatch(updateSettings(_objectSpread(_objectSpread({}, initialState.settings), settings)));

            // Get flow outline
            _context3.next = 13;
            return _cccisdAxios["default"].get(Boilerplate.route('flow.builder.entity.outline', {
              flow_id: flowId
            }));
          case 13:
            response = _context3.sent;
            dispatch(setList({
              list: response.data.data.tree,
              elementTypes: _allElements["default"]
            }));
            dispatch(unsetLoadingState());
          case 16:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x6, _x7) {
      return _ref6.apply(this, arguments);
    };
  }();
};
exports.loadFlow = loadFlow;
var savePlayerSettings = function savePlayerSettings(flowId) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(dispatch, getState) {
      var state, builder, data;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            state = getState();
            builder = state.flow.builder;
            data = {
              settings: JSON.stringify((0, _omit2["default"])(builder.settings, ['name', 'handle', 'type']))
            };
            _context4.next = 5;
            return _cccisdAxios["default"].put(Boilerplate.route('flow.update', {
              flow: flowId
            }), data);
          case 5:
            (0, _cccisdNotification["default"])('The player settings have been saved');
          case 6:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x8, _x9) {
      return _ref7.apply(this, arguments);
    };
  }();
};
exports.savePlayerSettings = savePlayerSettings;
var saveFlow = function saveFlow(flowId, codebookId) {
  var saveFlowThunk = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(dispatch, getState) {
      var state, builder, tree, response, needToSaveAgain;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            dispatch(setLoadingState());
            state = getState();
            builder = state.flow.builder; // Save flow tree
            tree = (0, _builder.getElementTreeForSaving)(builder);
            (0, _forEach2["default"])((0, _builder.getDeletedElements)(builder), function (deletedId) {
              // Add deleted elements
              tree.children.push({
                id: deletedId,
                status: 'deleted'
              });
            });
            _context5.next = 7;
            return _cccisdAxios["default"].put(Boilerplate.route('flow.builder.entity.batch.update', {
              flow_id: flowId
            }), {
              data: {
                tree: tree
              }
            });
          case 7:
            response = _context5.sent;
            // Checking if we have some data connectors to the new elements
            // In this case we have to get real ids and then save it again
            needToSaveAgain = (0, _helpers.checkIfNeedToSaveAgain)(builder.elements, response.data.data);
            dispatch(updateList(response.data.data));
            if (!needToSaveAgain) {
              _context5.next = 15;
              break;
            }
            _context5.next = 13;
            return saveFlowThunk(dispatch, getState);
          case 13:
            _context5.next = 18;
            break;
          case 15:
            dispatch(saveStateInStorage());
            dispatch(unsetLoadingState());
            dispatch(saveDataDefinitions(flowId, codebookId));
          case 18:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function saveFlowThunk(_x10, _x11) {
      return _ref8.apply(this, arguments);
    };
  }();
  return saveFlowThunk;
};

// Reducer
exports.saveFlow = saveFlow;
var _default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, SET_LOADING_STATE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: true
  });
}), _defineProperty(_handleActions, UNSET_LOADING_STATE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: false
  });
}), _defineProperty(_handleActions, RESET_FLOW, function (state, action) {
  return _objectSpread({}, initialState);
}), _defineProperty(_handleActions, ADD_ELEMENT, function (state, action) {
  var _objectSpread2;
  var _action$payload = action.payload,
    element = _action$payload.element,
    settings = _action$payload.settings,
    parentId = _action$payload.parentId,
    beforeId = _action$payload.beforeId;
  if (!parentId) {
    parentId = state.rootId;
    beforeId = 0;
  }
  if (!state.elements[parentId]) {
    throw new Error("There is no element with parentId=".concat(parentId));
  }
  var newId = state.newId;
  var newElement = _objectSpread({
    id: newId,
    isNew: true,
    undoIterator: 0,
    // for new element we use element.code
    // for duplicated element we use element.type
    type: element.code || element.type,
    settings: settings,
    settingsHash: (0, _helpers.getObjectHash)(settings)
  }, (0, _pick2["default"])(element, ['skipPlaying', 'returnControlAfterChildren', 'isAloneOnThePage', 'isParentAllowed', 'isChildAllowed']));
  if (element.isAdult) {
    newElement.isAdult = true;
    newElement.children = [];
  }
  var elementList = state.elements[parentId].children;
  var beforeIndex = elementList.indexOf(beforeId);
  var newElementList;
  if (beforeIndex === -1) {
    newElementList = [].concat(_toConsumableArray(elementList), [newId]);
  } else {
    newElementList = [].concat(_toConsumableArray(elementList.slice(0, beforeIndex)), [newId], _toConsumableArray(elementList.slice(beforeIndex)));
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    newId: newId + 1,
    elements: _objectSpread(_objectSpread({}, state.elements), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, parentId, _objectSpread(_objectSpread({}, state.elements[parentId]), {}, {
      children: newElementList
    })), _defineProperty(_objectSpread2, newId, newElement), _objectSpread2)),
    currentElementId: (0, _isEmpty2["default"])(settings) ? state.currentElementId : newId
  });
}), _defineProperty(_handleActions, IMPORT_ELEMENTS, function (state, action) {
  var _action$payload2 = action.payload,
    parentId = _action$payload2.parentId,
    beforeId = _action$payload2.beforeId;
  if (!parentId) {
    parentId = state.rootId;
    beforeId = 0;
  }
  if (!state.elements[parentId]) {
    throw new Error("There is no element with parentId=".concat(parentId));
  }
  var _replaceIds = (0, _helpers.replaceIds)(action.payload.elements, action.payload.topId, state.newId),
    elements = _replaceIds.elements,
    topId = _replaceIds.topId,
    newId = _replaceIds.newId;
  var topElement = elements[topId];
  var additionalChildren = topElement.type ? [topId] : elements[topId].children;
  var children = state.elements[parentId].children;
  var beforeIndex = children.indexOf(beforeId);
  var newChildren;
  if (beforeIndex === -1) {
    newChildren = [].concat(_toConsumableArray(children), _toConsumableArray(additionalChildren));
  } else {
    newChildren = [].concat(_toConsumableArray(children.slice(0, beforeIndex)), _toConsumableArray(additionalChildren), _toConsumableArray(children.slice(beforeIndex)));
  }
  var newElements = topElement.type ? elements : (0, _pickBy2["default"])(elements, function (o) {
    return o.id !== topId;
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    elements: _objectSpread(_objectSpread({}, state.elements), {}, _defineProperty({}, parentId, _objectSpread(_objectSpread({}, state.elements[parentId]), {}, {
      children: newChildren
    })), (0, _mapValues2["default"])(newElements, function (o) {
      return _objectSpread(_objectSpread({}, o), {}, {
        isNew: true,
        undoIterator: 0,
        settingsHash: (0, _helpers.getObjectHash)(o.settings)
      });
    })),
    newId: newId
  });
}), _defineProperty(_handleActions, MOVE_ELEMENT, function (state, action) {
  var _action$payload3 = action.payload,
    id = _action$payload3.id,
    parentId = _action$payload3.parentId,
    beforeId = _action$payload3.beforeId;
  if (!state.elements[parentId]) {
    throw new Error("There is no element with parentId=".concat(parentId));
  }
  var elementList = (0, _difference2["default"])(state.elements[parentId].children, [id]);
  var beforeIndex = elementList.indexOf(beforeId);
  var newElementList;
  if (beforeIndex === -1) {
    newElementList = [].concat(_toConsumableArray(elementList), [id]);
  } else {
    newElementList = [].concat(_toConsumableArray(elementList.slice(0, beforeIndex)), [id], _toConsumableArray(elementList.slice(beforeIndex)));
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    elements: _objectSpread(_objectSpread({}, (0, _mapValues2["default"])(state.elements, function (element) {
      if (!element.children) {
        return element;
      }
      return _objectSpread(_objectSpread({}, element), {}, {
        children: (0, _difference2["default"])(element.children, [id])
      });
    })), {}, _defineProperty({}, parentId, _objectSpread(_objectSpread({}, state.elements[parentId]), {}, {
      children: newElementList
    })))
  });
}), _defineProperty(_handleActions, CHANGE_CURRENT_ELEMENT, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currentElementId: action.payload,
    elements: _objectSpread(_objectSpread({}, state.elements), {}, _defineProperty({}, action.payload, _objectSpread({}, (0, _omit2["default"])(state.elements[action.payload], 'showPreview'))))
  });
}), _defineProperty(_handleActions, CHANGE_VIEW_MODE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    viewMode: action.payload,
    elements: (0, _mapValues2["default"])(state.elements, function (element) {
      return (0, _omit2["default"])(element, 'showPreview');
    })
  });
}), _defineProperty(_handleActions, UPDATE_CURRENT_ELEMENT_SETTINGS, function (state, action) {
  var id = state.currentElementId;
  var newSettings = action.payload;
  var oldSettingsHash = state.elements[id].settingsHash;
  var newSettingsHash = (0, _helpers.getObjectHash)(newSettings);
  if (oldSettingsHash === newSettingsHash) {
    return state;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    elements: _objectSpread(_objectSpread({}, state.elements), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, state.elements[id]), {}, {
      redoSettings: null,
      settings: newSettings,
      settingsHash: newSettingsHash
    })))
  });
}), _defineProperty(_handleActions, TOGGLE_ELEMENT_PREVIEW, function (state, action) {
  var viewMode = state.viewMode;
  var isCurrent = state.currentElementId === action.payload;
  var element = state.elements[action.payload];
  var showPreview;
  if (element.showPreview === undefined) {
    showPreview = viewMode === 'preview' || isCurrent ? false : true;
  } else {
    showPreview = !element.showPreview;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    elements: _objectSpread(_objectSpread({}, state.elements), {}, _defineProperty({}, action.payload, _objectSpread(_objectSpread({}, element), {}, {
      showPreview: showPreview
    })))
  });
}), _defineProperty(_handleActions, INITIALIZE_SAVED_LIST, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    savedElements: state.elements
  });
}), _defineProperty(_handleActions, REMOVE_REDOS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    elements: (0, _mapValues2["default"])(state.elements, function (element) {
      return _objectSpread(_objectSpread({}, element), {}, {
        redoSettings: null
      });
    })
  });
}), _defineProperty(_handleActions, UNDO_CHANGES, function (state, action) {
  var id = action.payload;
  var savedElement = state.savedElements[id];
  if (!savedElement) {
    return state;
  }
  var element = state.elements[id];
  return _objectSpread(_objectSpread({}, state), {}, {
    elements: _objectSpread(_objectSpread({}, state.elements), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, element), {}, {
      undoIterator: element.undoIterator - 1,
      redoSettings: element.settings,
      settings: savedElement.settings,
      settingsHash: savedElement.settingsHash
    })))
  });
}), _defineProperty(_handleActions, REDO_CHANGES, function (state, action) {
  var id = action.payload;
  var element = state.elements[id];
  if (!element || !element.redoSettings) {
    return state;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    elements: _objectSpread(_objectSpread({}, state.elements), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, element), {}, {
      undoIterator: element.undoIterator + 1,
      redoSettings: null,
      settings: element.redoSettings,
      settingsHash: (0, _helpers.getObjectHash)(element.redoSettings)
    })))
  });
}), _defineProperty(_handleActions, UPDATE_SETTINGS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    settings: _objectSpread(_objectSpread({}, state.settings), action.payload)
  });
}), _defineProperty(_handleActions, SET_ROOT_ID, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    rootId: action.payload
  });
}), _defineProperty(_handleActions, SET_PROJECT_ID, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    projectId: action.payload
  });
}), _defineProperty(_handleActions, SET_ASSIGNMENT_ID, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    assignmentId: action.payload
  });
}), _defineProperty(_handleActions, SET_LANGUAGE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    language: action.payload
  });
}), _defineProperty(_handleActions, SET_LIST, function (state, action) {
  var _action$payload4 = action.payload,
    list = _action$payload4.list,
    elementTypes = _action$payload4.elementTypes;
  var rootId = list.id;
  var elements = {};
  function processChildren(parent) {
    var children = parent.children ? parent.children.map(function (element) {
      return element.id;
    }) : [];
    if (parent.id === rootId) {
      elements[rootId] = {
        id: rootId,
        children: children
      };
      if (parent.children) {
        parent.children.forEach(function (child) {
          return processChildren(child);
        });
      }
    } else {
      var elementType = (0, _find2["default"])(elementTypes, {
        code: parent.type
      });
      if (!elementType) {
        throw new Error("Unknown type \"".concat(parent.type, "\""));
      }
      var settings = parent.content[0];
      elements[parent.id] = _objectSpread({
        id: parent.id,
        type: parent.type,
        undoIterator: 0,
        settingsId: settings.id,
        settings: settings.content,
        settingsHash: (0, _helpers.getObjectHash)(settings.content)
      }, (0, _pick2["default"])(elementType, ['skipPlaying', 'returnControlAfterChildren', 'isAloneOnThePage', 'isParentAllowed', 'isChildAllowed']));
      if (elementType.isAdult) {
        elements[parent.id].isAdult = true;
        elements[parent.id].children = children;
        if (parent.children) {
          parent.children.forEach(function (child) {
            return processChildren(child);
          });
        }
      }
    }
  }
  processChildren(list);
  return _objectSpread(_objectSpread({}, state), {}, {
    rootId: rootId,
    currentElementId: elements[rootId].children[0],
    elements: elements,
    savedElements: elements,
    trash: []
  });
}), _defineProperty(_handleActions, UPDATE_LIST, function (state, action) {
  var currentElementId = state.currentElementId;
  var elements = {};
  var replacements = {};
  (0, _forEach2["default"])(state.elements, function (item, key) {
    if (!item.isNew) {
      elements[key] = item;
      return;
    }
    var found = (0, _find2["default"])(action.payload, {
      tmpId: +key
    });
    if (!found) {
      throw new Error("There is no element with tmpId=".concat(item.id));
    }
    replacements[key] = found.id;

    // Change currentElementId if it was the new element
    if (+key === currentElementId) {
      currentElementId = found.id;
    }
    elements[found.id] = _objectSpread(_objectSpread({}, (0, _omit2["default"])(item, 'isNew')), {}, {
      id: found.id,
      settingsId: found.content[0].id
    });
  });
  elements = (0, _mapValues2["default"])(elements, function (item) {
    if (!item.children) {
      return item;
    }
    return _objectSpread(_objectSpread({}, item), {}, {
      children: item.children.map(function (id) {
        return replacements[id] || id;
      })
    });
  });
  function replaceConnectorIds(item, key, collection) {
    if (!(0, _isObject2["default"])(item) && !(0, _isArray2["default"])(item)) {
      return;
    }
    if ((0, _isObject2["default"])(item) && item.instance === 'dataConnector' && item.category === 'flow') {
      collection[key] = _objectSpread(_objectSpread({}, item), {}, {
        id: replacements[item.id] || item.id
      });
      return;
    }
    (0, _forEach2["default"])(item, replaceConnectorIds);
  }
  replaceConnectorIds(elements);
  return _objectSpread(_objectSpread({}, state), {}, {
    currentElementId: currentElementId,
    elements: elements,
    savedElements: elements,
    trash: []
  });
}), _defineProperty(_handleActions, MOVE_ELEMENT_TO_TRASH, function (state, action) {
  var id = action.payload;
  function getAllDescendantIds(elementId) {
    if (!state.elements[elementId].children) {
      return [];
    }
    return state.elements[elementId].children.reduce(function (acc, childId) {
      return [].concat(_toConsumableArray(acc), [childId], _toConsumableArray(getAllDescendantIds(childId)));
    }, []);
  }
  var movedIds = [id].concat(_toConsumableArray(getAllDescendantIds(id)));
  return _objectSpread(_objectSpread({}, state), {}, {
    elements: (0, _mapValues2["default"])((0, _omit2["default"])(state.elements, movedIds), function (element) {
      if (!element.children) {
        return element;
      }
      return _objectSpread(_objectSpread({}, element), {}, {
        children: (0, _difference2["default"])(element.children, movedIds)
      });
    }),
    trash: [].concat(_toConsumableArray((0, _map2["default"])((0, _pick2["default"])(state.elements, movedIds), function (element) {
      var result = (0, _helpers.removeDataConnectors)((0, _omit2["default"])(element, 'children'));
      if (result.isAdult) {
        result.children = [];
      }
      return result;
    })), _toConsumableArray(state.trash))
  });
}), _defineProperty(_handleActions, MOVE_ELEMENT_FROM_TRASH, function (state, action) {
  var _objectSpread10;
  var _action$payload5 = action.payload,
    id = _action$payload5.id,
    parentId = _action$payload5.parentId,
    _action$payload5$befo = _action$payload5.beforeId,
    beforeId = _action$payload5$befo === void 0 ? 0 : _action$payload5$befo;
  if (!state.elements[parentId]) {
    throw new Error("There is no element with parentId=".concat(parentId));
  }
  var element = (0, _find2["default"])(state.trash, {
    id: id
  });
  var elementList = state.elements[parentId].children;
  var beforeIndex = elementList.indexOf(beforeId);
  var newElementList;
  if (beforeIndex === -1) {
    newElementList = [].concat(_toConsumableArray(elementList), [id]);
  } else {
    newElementList = [].concat(_toConsumableArray(elementList.slice(0, beforeIndex)), [id], _toConsumableArray(elementList.slice(beforeIndex)));
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    elements: _objectSpread(_objectSpread({}, state.elements), {}, (_objectSpread10 = {}, _defineProperty(_objectSpread10, parentId, _objectSpread(_objectSpread({}, state.elements[parentId]), {}, {
      children: newElementList
    })), _defineProperty(_objectSpread10, id, element), _objectSpread10)),
    trash: (0, _filter2["default"])(state.trash, function (item) {
      return item.id !== id;
    })
  });
}), _defineProperty(_handleActions, RESTORE_STATE, function (state, action) {
  var _action$payload6 = action.payload,
    savedState = _action$payload6.savedState,
    keys = _action$payload6.keys;
  if (!savedState[state.rootId]) {
    return state;
  }
  return _objectSpread(_objectSpread({}, state), (0, _pick2["default"])(savedState[state.rootId], keys));
}), _defineProperty(_handleActions, COMPLETE_SECTION_TREE, function (state, action) {
  var sectionCount = action.payload;
  var rootId = state.rootId,
    elements = state.elements;

  // Check if all the top level elements are adult
  elements[rootId].children.forEach(function (child) {
    if (!elements[child].isAdult) {
      throw new Error('Every top level element should be an adult');
    }
  });
  var count = elements[rootId].children.length;
  if (count >= sectionCount) {
    return state;
  }
  var newId = state.newId;
  var newElements = {};
  var newElementsIds = [];
  for (var i = 0; i < sectionCount - count; i++) {
    newElements[newId] = {
      id: newId,
      type: 'section',
      isNew: true,
      undoIterator: 0,
      settings: {},
      settingsHash: (0, _helpers.getObjectHash)({}),
      isAdult: true,
      children: []
    };
    newElementsIds.push(newId);
    newId++;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    newId: newId,
    elements: _objectSpread(_objectSpread(_objectSpread({}, elements), newElements), {}, _defineProperty({}, rootId, _objectSpread(_objectSpread({}, elements[rootId]), {}, {
      children: [].concat(_toConsumableArray(elements[rootId].children), newElementsIds)
    })))
  });
}), _defineProperty(_handleActions, BATCH_UPDATE_AUDIO, function (state, action) {
  var _action$payload7 = action.payload,
    source = _action$payload7.source,
    tts = _action$payload7.tts;
  var newElements = (0, _cloneDeep2["default"])(state.elements);
  var _iterator = _createForOfIteratorHelper(source),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _field;
      var item = _step.value;
      var fullPath = "".concat(item.elementId, ".settings.").concat(item.path);
      var fieldTts = tts["".concat(item.elementId, "_").concat(item.path)];
      var meta = {
        tts: {
          voice: item.voice,
          text: item.text
        },
        audio: {
          id: fieldTts.resourceId,
          resourceId: fieldTts.resourceId,
          isAsset: true,
          url: fieldTts.url
        }
      };
      var field = (0, _get2["default"])(newElements, fullPath);
      if ((_field = field) !== null && _field !== void 0 && _field.content) {
        field = _objectSpread(_objectSpread({}, field), {}, {
          meta: _objectSpread(_objectSpread({}, field.meta), meta)
        });
      } else {
        field = {
          content: field,
          meta: meta
        };
      }
      (0, _set2["default"])(newElements, fullPath, field);

      // regenerate settings hash
      newElements[item.elementId].settingsHash = (0, _helpers.getObjectHash)(newElements[item.elementId].settings);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    elements: newElements
  });
}), _defineProperty(_handleActions, CHANGE_PREVIEW_SIZE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    previewSize: action.payload
  });
}), _handleActions), initialState);
exports["default"] = _default;